function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { V1View } from '@intercom/interblocks.ts';
const defaultWidth = '100%';
const defaultBorderStyle = 'solid';
const defaultBorderWidth = '2px';
const defaultBorderColor = '#222222';
export default class HorizontalRuleView {
  constructor(node, config) {
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "view", void 0);
    this.dom = document.createElement('div');
    let innerDom = document.createElement('div');
    this.dom.appendChild(innerDom);
    this.dom.classList.add('embercom-prosemirror-composer-divider');
    let isTemplated = false;
    let renderAnchors = false;
    if (config?.renderDivider) {
      node.attrs.width = node.attrs.width || defaultWidth;
      node.attrs.borderColor = node.attrs.borderColor || defaultBorderColor;
      node.attrs.borderStyle = node.attrs.borderStyle || defaultBorderStyle;
      node.attrs.borderWidth = node.attrs.borderWidth || defaultBorderWidth;
    }
    this.view = new V1View(innerDom, isTemplated, config.templating?.resolver, renderAnchors, config?.renderDivider);
    try {
      this.view.render([{
        type: 'horizontalRule',
        width: node.attrs.width,
        text: node.attrs.text,
        style: {
          borderColor: node.attrs.borderColor,
          borderWidth: node.attrs.borderWidth,
          borderStyle: node.attrs.borderStyle
        }
      }]);
    } catch (e) {
      console.log(e);
    }
  }
}